<template>
  <AsyncData :request-state="requestState">
    <v-data-table
      :headers="headers"
      :items="filteredItems"
      :total-items="response.total"
      item-key="caseId"
      :pagination.sync="proxyPagination"
      :rows-per-page-items="[2, 10, 25, 50, 100]"
      rowsPerPage>
      <template slot="items" slot-scope="props">
        <analytics-data-item :item="props.item"/>
      </template>
    </v-data-table>
  </AsyncData>
</template>

<script>
  import {mapActions, mapState} from "vuex";
  import _ from 'lodash'
  import AsyncData from "../Ui/AsyncData";
  import DateWithMinutes from '../Filters/DateWithMinutes.js'
  import NoEmpty from '../Filters/NoEmpty'
  import {calculateExecutedPrice, resolveCaseServicePageUrl} from './utils';
  import AnalyticsDataItem from "./AnalyticsDataItem";

  function isItemContainAnomaliesOfType(item, anomalies) {
    return _.findIndex(item.caseAnomalies, it => anomalies.includes(it.type)) > -1
  }

  export default {
    name: 'analytics-data',
    components: {
      AsyncData,
      AnalyticsDataItem
    },
    filters: {
      NoEmpty,
      DateWithMinutes
    },
    props: {},
    data() {
      return {
        showModal: false,
        headers: [
          {
            text: 'Title',
            align: 'left',
            sortable: false,
            value: 'title',
            width: '100px'
          },
          {
            text: 'Status',
            align: 'left',
            sortable: false,
            value: 'status',
            width: '100px'
          },
          {
            text: 'Dates(creation, materials, report sending)',
            align: 'left',
            sortable: false,
            value: 'date',
            width: '200px'
          },
          {
            text: 'Patient Name',
            align: 'left',
            sortable: false,
            value: 'patientName',
            width: '100px'
          },
          {
            text: 'Client',
            align: 'left',
            sortable: false,
            value: 'client',
            width: '100px'
          },
          {
            text: 'Comment',
            align: 'left',
            sortable: false,
            value: 'comment',
            width: '100px'
          },
          {
            text: 'Price',
            align: 'left',
            sortable: false,
            width: '100px'
          },
          {
            text: 'Operations',
            align: 'left',
            sortable: false,
            width: '100px'
          },
          {
            text: 'Services',
            align: 'left',
            sortable: false,
            width: '200px'
          },
          {
            text: 'Materials',
            align: 'left',
            sortable: false,
            width: '200px'
          },
        ],
      }
    },
    computed: {
      ...mapState({
        clientFilter: state => state.analytics.clientFilter,
        pagination: state => state.analytics.filter.pagination,
        response: state => state.analytics.response,
        requestState: state => state.analytics.requestState
      }),
      proxyPagination: {
        get() {
          return {
            page: this.pagination.page,
            rowsPerPage: this.pagination.rowsPerPage
          };
        },
        set(newValue) {
          let newPagination = {
            page: newValue.page,
            rowsPerPage: newValue.rowsPerPage
          };

          if (_.isEqual(this.proxyPagination, newPagination)) {
            return
          }

          this.changeAnalyticsFilter({
            pagination: newPagination
          })
        },
      },
      filteredItems() {
        // anomaly filter
        let result = this.response.items;
        if (this.clientFilter.caseAnomalies.length > 0) {
          result = _.filter(result, it => isItemContainAnomaliesOfType(it, this.clientFilter.caseAnomalies))
        }

        // price
        if (this.clientFilter.executedPriceOver9000) {
          result = _.filter(result, it => this.calculateExecutedPrice(it).amount > 9000)
        }

        return result;
      }
    },
    methods: {
      ...mapActions({
        changeAnalyticsFilter: 'changeAnalyticsFilter'
      }),
      resolveCaseServicePageUrl(caseId) {
        return resolveCaseServicePageUrl(this.$router, caseId)
      },
      calculateExecutedPrice(item) {
        return calculateExecutedPrice(item)
      }
    },
  }
</script>

<style scoped>
  .caseServicesLink {
    margin-left: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/analytics/AnalyticsData.vue